import React from 'react';

import styled from 'styled-components';

import { AICIPerformanceType } from 'components/AiCompetitiveIntelligence/constants';

import { CommunityName, RankCell } from '../AiCiTableWrapper';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
`;

const IndexNumber = styled(RankCell)`
  flex-shrink: 0;
  padding-left: 9px;
`;

const Details = styled.div`
  min-width: 0;
`;

const PerformanceBadge = styled.div`
  margin-top: 2px;
  font-size: 12px;
  font-family: var(--font-regular);

  &.leading {
    color: var(--positive-green);
  }
  &.lagging {
    color: var(--inactive-orange);
  }
  &.neutral {
    color: var(--text-secondary);
  }
`;

type Props = {
  position: number;
  name: string;
  performance: AICIPerformanceType | null;
};

const CommunityCell = ({ position, name, performance }: Props) => (
  <Container>
    <IndexNumber>{position}</IndexNumber>
    <Details>
      <CommunityName>{name}</CommunityName>
      {performance && (
        <PerformanceBadge className={performance}>
          {performance.charAt(0).toUpperCase() + performance.slice(1)}
        </PerformanceBadge>
      )}
    </Details>
  </Container>
);

export default CommunityCell;
